import { LINK_SUCCESS, LINK_FAIL, LOAD_LINK } from '../action.types';
import initialState from '../initial.state';

export default function(state = initialState.link, action) {
  switch (action.type) {
    case LINK_SUCCESS:
      return { ...action.payload.data };
    case LINK_FAIL:
      return state;
    case LOAD_LINK:
      return { ...action.link };
    default:
      return state;
  }
}
